import { defineMessages } from 'react-intl';

export default defineMessages({
  collateralSeized: 'Collateral seized',
});
